import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  // URL'den dil algılama
  const isEnglishPage = location.pathname.startsWith('/en');

  const handleHomeClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const homePath = isEnglishPage ? '/en' : '/';
    window.REACT_APP_NAVIGATE(homePath);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  };

  const handleKatalogClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const catalogPath = isEnglishPage ? '/en/catalog' : '/katalog';
    window.REACT_APP_NAVIGATE(catalogPath);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }, 0);
  };

  const handleFuarlarClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const fairsPath = isEnglishPage ? '/en/fairs' : '/fuarlar';
    window.REACT_APP_NAVIGATE(fairsPath);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }, 0);
  };

  const handleKesimKalinliklariClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const cuttingPath = isEnglishPage ? '/en/cutting-thickness' : '/kesim-kalinliklari';
    window.REACT_APP_NAVIGATE(cuttingPath);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }, 0);
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img 
                src={isEnglishPage
                  ? "https://static.readdy.ai/image/9eedc5e2dd53bc7772895ba1e507e110/5cdb8acd1a926456732ace3d319bea51.png"
                  : "https://static.readdy.ai/image/9eedc5e2dd53bc7772895ba1e507e110/a0b9b0f9707db545f480592d32a34f17.png"
                }
                alt={isEnglishPage ? "AJAN LASER" : "AJAN LAZER"}
                className="h-8 w-auto"
              />
            </div>
            <p className="text-lg leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-[22px]">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href={isEnglishPage ? '/en' : '/'} 
                  onClick={handleHomeClick}
                  className="text-lg hover:text-[#D62828] transition-colors cursor-pointer"
                >
                  {t('footer.home')}
                </a>
              </li>
              <li>
                <a 
                  href={isEnglishPage ? '/en/catalog' : '/katalog'} 
                  onClick={handleKatalogClick}
                  className="text-lg hover:text-[#D62828] transition-colors cursor-pointer"
                >
                  {t('footer.catalog')}
                </a>
              </li>
              <li>
                <a 
                  href={isEnglishPage ? '/en/cutting-thickness' : '/kesim-kalinliklari'} 
                  onClick={handleKesimKalinliklariClick}
                  className="text-lg hover:text-[#D62828] transition-colors cursor-pointer"
                >
                  {t('footer.cuttingThickness')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-[22px]">{t('footer.contact')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-[#D62828] mt-1"></i>
                <div>
                  <div className="text-lg">
                    <span className="font-medium text-white">{t('footer.factory')}</span>
                    <a href={isEnglishPage ? "tel:+902323281202" : "tel:02323281202"} className="ml-1 hover:text-[#D62828] transition-colors">
                      {isEnglishPage ? '+90 232 328 12 02' : '(0232) 328 12 02'}
                    </a>
                  </div>
                  <div className="text-lg mt-1">
                    <span className="font-medium text-white">{t('footer.customerService')}</span>
                    <a href={isEnglishPage ? "tel:+904442526" : "tel:4442526"} className="ml-1 hover:text-[#D62828] transition-colors">
                      {isEnglishPage ? '+90 444 25 26' : '444 25 26'}
                    </a>
                  </div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-[#D62828] mt-1"></i>
                <div>
                  <a href="mailto:info@ajancnc.com" className="text-lg hover:text-[#D62828] transition-colors">
                    info@ajancnc.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-[#D62828] mt-1"></i>
                <div>
                  <p className="text-lg font-medium text-white">Ajan Elektronik Servis San. ve Tic. Ltd. Sti.</p>
                  <a 
                    href="https://www.google.com/maps/place/Ajan+Elektronik+Servis+San.+Ve+Tic.+Ltd.+%C5%9Eti./@38.4977702,27.0300792,15z/data=!4m5!3m4!1s0x0:0xb3e428f303d2e3d8!8m2!3d38.4977701!4d27.03008?coh=164777&entry=tt&shorturl=1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-lg hover:text-[#D62828] transition-colors cursor-pointer"
                  >
                    10039 Sok. No:10 AOSB- Cigli/Izmir 35620 Türkiye
                  </a>
                </div>
              </li>
            </ul>
          </div>

          {/* Certifications */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-[22px]">{t('footer.certifications')}</h3>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <i className="ri-award-line text-[#D62828]"></i>
                <span className="text-lg">{t('footer.ceCertificate')}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-[#D62828]"></i>
                <span className="text-lg">{t('footer.iso9001')}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-flashlight-line text-[#D62828]"></i>
                <span className="text-lg">{t('footer.emcLvdTests')}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-plug-line text-[#D62828]"></i>
                <span className="text-lg">{t('footer.tsEnIso12100')}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-lg text-gray-400">
              {t('footer.rights')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
